module.exports = __webpack_public_path__ + "static/media/2 (7).e9021675.jpg";